import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { url: String }
  static targets = ['menu', 'placeholder']

  async load() {
    if (this.loaded) return

    this.loaded = true

    try {
      const response = await fetch(this.urlValue, { headers: { Accept: 'text/html' } })
      if (!response.ok) throw new Error(response.statusText)

      this.menuTarget.innerHTML = await response.text()
    } catch {
      this.loaded = false
      if (this.hasPlaceholderTarget) this.placeholderTarget.textContent = 'Could not load actions — try again'
    }
  }
}
